export default __webpack_public_path__ + "static/media/shoes4.8909d263.png";